import { render, staticRenderFns } from "./jiaoyishuju.vue?vue&type=template&id=93543272&scoped=true"
import script from "./jiaoyishuju.vue?vue&type=script&lang=js"
export * from "./jiaoyishuju.vue?vue&type=script&lang=js"
import style0 from "./jiaoyishuju.vue?vue&type=style&index=0&id=93543272&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93543272",
  null
  
)

export default component.exports